import { useGetOrderQuery } from '@src/services/order/orderApiSlice';
import { OrderPaymentResult, TopUpPaymentResult } from './components';
import { useGetTopUpHistoryQuery } from '@src/services/topUp/topUpApiSlice';
import { WidgetSkeleton } from '@src/components/Loading/WidgetSkeleton';
import { PaymentStatus } from '@src/types/payment';
import { useQueryParams } from '@src/hooks';

export function OrderPaymentResultPage() {
  const { getQueryParam } = useQueryParams();
  const orderId = getQueryParam('orderId') ?? undefined;
  const status = getQueryParam('status') ?? undefined;

  const { data: orderData, isLoading: orderLoading } = useGetOrderQuery(
    { id: orderId ?? '' },
    { skip: !orderId }
  );

  const { data: topUpHistories, isLoading: topUpLoading } =
    useGetTopUpHistoryQuery({});

  function normalizeStatus(
    status: string | null | undefined
  ): PaymentStatus | undefined {
    if (!status) return undefined;
    const lowered = status.toLowerCase();
    return ['success', 'failed', 'pending'].includes(lowered as PaymentStatus)
      ? (lowered as PaymentStatus)
      : undefined;
  }

  if (orderLoading || topUpLoading)
    return (
      <div className='flex items-center justify-center h-full p-4 bg-white dark:bg-black lg:bg-gradient-to-b lg:from-wl-surface lg:to-wl-primary-p20 overflow-auto overflow-y-hidden'>
        <div className='h-full w-full flex items-center justify-center'>
          <WidgetSkeleton />
        </div>
      </div>
    );

  if (orderData) {
    return (
      <OrderPaymentResult
        orderData={orderData}
        status={normalizeStatus(status)}
      />
    );
  }

  if (topUpHistories && topUpHistories.length > 0) {
    const topUpHistory = topUpHistories.find((h) => h.id === orderId);

    if (topUpHistory) {
      return (
        <TopUpPaymentResult
          topUpHistory={topUpHistory}
          status={normalizeStatus(status)}
        />
      );
    }
  }

  return (
    <div className='flex items-center justify-center h-full p-4 bg-white dark:bg-black'>
      <p className='text-gray-500 dark:text-gray-400'>
        Order or top-up not found.
      </p>
    </div>
  );
}
